<template>
	<div v-if="isshow">
		<div class="section-a">
			<div class="section-a-t">
				<div class="section-a-t-t">
					<img :src="gradeData.userinfo.avatar" alt="">
					<p>{{ gradeData.level_info.name }}</p>
				</div>
				<ul class='tabs'>
					<li
					  class='tab-list'
					  :class="item.display == 3 ? 'tab-list-soon' : ''"
					  v-for="(item,key) in gradeData.level_list"
					  :key="key"
					>
					  {{ item.name }}
					  <div v-if="item.display == 1"><p class="in"></p></div>
					  <div v-if="item.display == 2"><p class="out"><span class="in"></span></p></div>
					  <div v-if="item.display == 3"><p class="soon"></p></div>
					</li>
				</ul>
			</div>
			<div class="section-a-pre">
				<div>
					<div class="section-a-pre-l">推</div>
					<div class="section-a-pre-r">
						<p>{{ gradeData.level_info.discount }}%</p>
						<p>推广佣金比</p>
					</div>
				</div>
				<div>
					<div class="section-a-pre-l">邀</div>
					<div class="section-a-pre-r">
						<p>{{ gradeData.level_info.discount_invited }}%</p>
						<p>邀请佣金比</p>
					</div>
				</div>
			</div>
			<div class="section-a-info"> <span>!</span> 部分商品的佣金比例可能因商家设置而有所不同，请以商品中所显示的为准</div>
		</div>
		<div class="section-b" v-if="gradeData.upgrade.next_name">
			<h2>满足以下规则可升级为{{ gradeData.upgrade.next_name }}</h2>
			<p><span>未达标</span>推广金额达{{ gradeData.upgrade.next_amount }}元（还差<i>{{ gradeData.upgrade.differ }}元</i>）</p>
		</div>
		<div class="section-c">
			<h2 class="section-c-title">等级规则</h2>
			<ul class="section-c-grade">
				<li v-for="(item,key) in gradeData.level_list" :key="key">
					<div class="grade-name">
						<img src="@assets/images/grade.png" alt="">{{ item.name }}
					</div>
					<div class="grade-info">
						<h3>规则介绍</h3>
						<p v-if="item.rule_type == 0">成为赋能宝爸宝妈后即是该等级</p>
						<p v-if="item.rule_type == 1">推广金额达{{ item.rule_price }}元</p>
					</div>
					<div class="grade-info">
						<h3>权益介绍</h3>
						<p>推广佣金比为{{ item.discount }}% 邀请佣金比为{{ item.discount_invited }}%</p>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { getGrade } from "@api/user";
export default{
	name:"GradeCenter",
	data:function(){
		return{
			isshow:false,
			gradeData:{}
		}
	},
	mounted:function(){
		this.getGrade();
	},
	methods:{
		getGrade(){
			let that = this;
			getGrade().then(res => {
				that.gradeData = res.data;
				that.isshow = true;
			}).catch(err => {
				that.$dialog.error(err.msg);
				setTimeout(function(){
					that.$router.push('/');  
				},1000);
			})
		}
	}
}
</script>

<style scoped>
.section-a{background-color: #fff;padding: 0.3rem;}
.section-a-t{background-color: #dfbc88;border-radius: 5px;width: 100%;padding: 0.3rem 0 0.3rem 0.3rem;}
.section-a-t-t{overflow: hidden;}
.section-a-t-t img{display: block;width: 0.88rem;float: left;border-radius: 50%;}
.section-a-t-t p{color: #fff;font-weight: bold;font-size: 0.35rem;float: left;line-height: 0.88rem;margin-left: 0.2rem;}
.tabs{width: 100%;overflow-x: scroll;display: -webkit-box;display: flex;-webkit-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-justify-content:space-between;justify-content:space-between;padding-top: 0.4rem;margin-left: -0.3rem;}
.tab-list{text-align: center;-webkit-flex:1 0 auto;flex:1 0 auto;border-top: 3px solid #efddc4;color: #fff;font-size: 0.26rem;width: 2.4rem;padding-top: 0.2rem;position: relative;}
.tab-list:first-child:before{content: "";position: absolute;left: 0;top: -3px;width: 50%;height: 3px;background-color: #dfbc88;}
.tab-list:last-child:before{content: "";position: absolute;right: 0;top: -3px;width: 50%;height: 3px;background-color: #dfbc88;}
.tab-list-soon{border-top: 3px solid #b99560;}
.tab-list div{width: 0.45rem;height: 0.25rem; background-color: #dfbc88;position: absolute;top: -0.17rem;left: 1rem;display: flex;justify-content: center;align-items: center;}
.tab-list div .out{padding: 0.06rem;background-color: #ecd9b9;border-radius: 50%;}
.tab-list div .in{width: 0.12rem;height: 0.12rem;background-color: #fff;border-radius: 50%;display: block;}
.tab-list div .soon{width: 0.12rem;height: 0.12rem;background-color: #f3e5cd;border-radius: 50%;}
.section-a-pre{display: flex;justify-content: center;padding: 0.3rem 0;}
.section-a-pre>div{width: 100%;overflow: hidden;}
.section-a-pre-l{float: left;width: 0.88rem;height: 0.88rem;line-height: 0.88rem;text-align: center;background-color: #fcf5e7;color: #dabb8a;border-radius: 50%;font-size: 0.36rem;}
.section-a-pre-r{float: left;margin-left: 0.2rem;}
.section-a-pre-r p{font-size: 0.28rem;}
.section-a-info{font-size: 0.26rem;color: #999;}
.section-a-info span{display: inline-block;width: 0.28rem;height: 0.28rem;text-align: center;line-height: 0.28rem;border: 1px solid #a0a0a0;border-radius: 50%;font-size: 0.2rem;}
.section-b{padding: 0.3rem;background-color: #fff;margin-top: 0.2rem;}
.section-b h2{font-size: 0.35rem;margin-bottom: 0.25rem;}
.section-b p{font-size: 0.28rem;}
.section-b p span{border: 1px solid #bbb;color: #bbb;font-size: 0.26rem;padding: 0 0.1rem;margin-right: 0.1rem;}
.section-b p i{color: #dabb8a;font-size: 0.28rem;}
.section-c{padding: 0.3rem;background-color: #fff;margin-top: 0.2rem;}
.section-c-title{font-size: 0.35rem;}
.section-c-grade li{padding-top: 0.4rem;}
.section-c-grade li .grade-name{width: 2.5rem;height: 0.48rem;line-height: 0.48rem; background-color: #f6f6f6;border-radius: 17px;font-size: 0.26rem;}
.section-c-grade li .grade-name img{width: 0.48rem;height: 0.48rem; display: inline-block;margin-right: 0.12rem;vertical-align: middle;}
.section-c-grade li .grade-info{margin-top: 0.4rem;margin-left: 0.6rem;}
.section-c-grade li .grade-info h3{font-size: 0.28rem;}
.section-c-grade li .grade-info p{font-size: 0.28rem;color: #999;margin-top: 0.1rem;}
</style>
